/****************************************************************************************************
 * hoph -> page-home > photo
****************************************************************************************************/
import { tlControl, tlPlayPause } from "./utils";


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Code for snippet
// let hophIsSnippet = true;
// if(hophIsSnippet && typeof hophIsRevert !== 'undefined') {
//   hophScrollClear();
// }



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Variables & Functions
let hophSel = '.sector.graphic .contents-wrapper.photography ';



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Scroll & Animation
let hophScrollTl1;
let hophScrollTl2;
let hophPhotoOnTl = null;
let hophTitle; // eslint-disable-line no-unused-vars
let hophCopyTl = null; // eslint-disable-line no-unused-vars
let hophWallLeftTl = null;
let hophWallRightTl = null;
let hophWallCenterTl = null;

///////// Wall base elements
let hophWallBaseT = [
  `${hophSel} .wall-top.wall-base .wall-cover .block01`,
  `${hophSel} .wall-top.wall-base .wall-cover .block02`,
  `${hophSel} .wall-top.wall-base .wall-cover .block03`,
  `${hophSel} .wall-top.wall-base .wall-cover .block04`,
  `${hophSel} .wall-top.wall-base .wall-cover .block05`,
];
let hophWallBaseB = [
  `${hophSel} .wall-bottom.wall-base .wall-cover .block01`,
  `${hophSel} .wall-bottom.wall-base .wall-cover .block02`,
  `${hophSel} .wall-bottom.wall-base .wall-cover .block03`,
  `${hophSel} .wall-bottom.wall-base .wall-cover .block04`,
  `${hophSel} .wall-bottom.wall-base .wall-cover .block05`,
];
let hophWallBaseL = [`${hophSel} .wall-left.wall-base .wall-cover`];
let hophWallBaseR = [
  `${hophSel} .wall-right.wall-base .wall-cover1`,
  `${hophSel} .wall-right.wall-base .wall-cover2`
];
let hophWallBaseC = [
  `${hophSel} .wall-center.wall-base .wall-cover .block01`,
  `${hophSel} .wall-center.wall-base .wall-cover .block02`,
  `${hophSel} .wall-center.wall-base .wall-cover .block03`,
  `${hophSel} .wall-center.wall-base .wall-cover .block04`,
  `${hophSel} .wall-center.wall-base .wall-cover .block05`,
];

///////// Wall object elements
let hophWallObjT = [
  `${hophSel} .wall-top.wall-object .wall-cover .block01`,
  `${hophSel} .wall-top.wall-object .wall-cover .block02`,
  `${hophSel} .wall-top.wall-object .wall-cover .block03`,
  `${hophSel} .wall-top.wall-object .wall-cover .block04`,
  `${hophSel} .wall-top.wall-object .wall-cover .block05`,
];
let hophWallObjB = [
  `${hophSel} .wall-bottom.wall-object .wall-cover .block01`,
  `${hophSel} .wall-bottom.wall-object .wall-cover .block02`,
  `${hophSel} .wall-bottom.wall-object .wall-cover .block03`,
  `${hophSel} .wall-bottom.wall-object .wall-cover .block04`,
  `${hophSel} .wall-bottom.wall-object .wall-cover .block05`,
];
let hophWallObjL = [`${hophSel} .wall-left.wall-object .wall-cover`];
let hophWallObjR = [`${hophSel} .wall-right.wall-object .wall-cover`];
let hophWallObjC = [
  `${hophSel} .wall-center.wall-object .wall-cover .block01`,
  `${hophSel} .wall-center.wall-object .wall-cover .block02`,
  `${hophSel} .wall-center.wall-object .wall-cover .block03`,
  `${hophSel} .wall-center.wall-object .wall-cover .block04`,
  `${hophSel} .wall-center.wall-object .wall-cover .block05`,
];

////////////////////////////////////////////////// Init
const hophInit = (gsapRef, splitTextRef) => {
  gsapRef.set(`${hophSel} .gallery-in-in`, {rotationX: '1deg'});

  gsapRef.set(`${hophSel} .wall-base .wall-bg`, {backgroundColor: '#000000'});

  gsapRef.set([
...hophWallBaseT, ...hophWallBaseB, ...hophWallBaseL, ...hophWallBaseR, ...hophWallBaseC,
...hophWallObjT, ...hophWallObjB, ...hophWallObjL, ...hophWallObjR, ...hophWallObjC
].join(','), {clearProps: 'all'});

  gsapRef.set(`${hophSel} .gallery-cover1`, {opacity: 1});
  gsapRef.set(`${hophSel} .gallery-cover2`, {opacity: 0});

  gsapRef.set(`${hophSel} .sector-copies`, {scale:1, opacity: 1});
  hophTitle = new splitTextRef(`${hophSel} .sector-copy.title .copy`, {type: 'chars,words', charsClass:'char char++'});
  gsapRef.set(`${hophSel} .sector-copy.title .copy .char`, {transformOrigin: 'left center', autoAlpha: 0, rotationX: '70deg', y: '20%', x: '-70%'});
  gsapRef.set(`${hophSel} .sector-copy.sentance .copy span`, { clearProps: 'all' });
  gsapRef.set(`${hophSel} .sector-copy.sentance .copy span`, { autoAlpha: 0,  y: '70%'});

  gsapRef.set(`${hophSel} .glass-cover-shadow, ${hophSel} .glass-cover-glow`, {opacity: 1});
}

////////////////////////////////////////////////// Photos & Photo: Set position and create sliding animation
const hophWallTlMake = (selWall, gsapRef) => {
  let photoTotalW = 0; // All photos's width combined
  let photoW = []; // Each photo's width
  let photoWPC = []; // Each photo's width in percentage
  let photoDist = [0]; // A photo's distance from the start positon inside its container

  document.querySelectorAll(`${selWall} .photo`).forEach(photo => {
    photoW.push(photo.offsetWidth);
    photoTotalW += photo.offsetWidth;
  });
  photoW.forEach((w, i) => {
    photoWPC.push(photoW[i] / photoTotalW);
    if(i > 0) photoDist.push(photoDist[i-1] + photoW[i-1]);
  });

  const getPhotoTotalW = () => Array.from(document.querySelectorAll(`${selWall} .photo`)).reduce((a, b) => a + b.offsetWidth ,   0);

  gsapRef.killTweensOf(`${selWall} .photo`);
  gsapRef.set(`${selWall} .photos, ${selWall} .photo`, {clearProps: 'all'});
  gsapRef.set(`${selWall} .photos`, {x: -photoW[0]});
  gsapRef.set(`${selWall} .photo`, {x: i => photoDist[i]});

  return gsapRef.to(`${selWall} .photo`, {
    paused: true,
    duration: 30,
    ease: "none",
     x: `+=${photoTotalW}`, //move each box photoTotalW to right
    modifiers: {
      x: gsapRef.utils.unitize(x => parseFloat(x) % photoTotalW) //force x to be between 0 and photoTotalW using modulus
    },
    repeat: -1
  });
}

////////////////////////////////////////////////// Scroll
const hophScrollMake = (gsapRef, scrollTriggerRef, smootherRef) => {
  
  //////////////////// Create photo wall sliding animation
  hophWallLeftTl = hophWallTlMake('.contents-wrapper.photography .wall-left.wall-base', gsapRef);
  hophWallRightTl = hophWallTlMake('.contents-wrapper.photography .wall-right.wall-base', gsapRef);
  hophWallCenterTl = hophWallTlMake('.contents-wrapper.photography .wall-center.wall-base', gsapRef);

  //////////////////// Scroll1: Photo area (placed on the bottom of the graphic sector) top 100% ~ 0%
  hophScrollTl1 = gsapRef.timeline({
    scrollTrigger: {
    id: 'hophScrollTl1',
    trigger: '.sector.graphic',
    toggleActions: 'restart complete reverse reset',
    start: 'bottom 160%', // Because of pinGrCardsShow = 0.4
    end: `bottom 60%`, // pinGrCardsShow = 0.4
    scrub: true,
    toggleClass: 'hophScrollTl1-active',
    // markers: {startColor: "black", endColor: "black", fontSize: "10px", fontWeight: "bold", indent: 0},
    onEnter: (self) =>{ hophElsControl('play'); },
    // onLeave: (self) => {},
    // onEnterBack: (self) => {},
    onLeaveBack: (self) => { hophElsControl('pause'); },
    }
  })
  .add(() => {}, 1)
  ;
   
  //////////////////// Photo on
  hophPhotoOnTl = gsapRef.timeline({
    scrollTrigger:{
      id: 'hophPhotoOnTl',
      trigger: '.sector.spacer-graphic',
      start: 'top top',
      end: '+=0',
      toggleActions: 'restart none reverse none',
      onEnter: (self) => {
        smootherRef.paused(true);
        // hophElsControl('play');
      },
      // onLeave: (self) => {},
      // onEnterBack: (self) => { },
      // onLeaveBack: (self) => {},
    },
    // onStart: () => {},
    onComplete: () => {
      smootherRef.paused(false);
    },
    onReverseComplete: () => {
      // hophElsControl('pause');
    }
  })
  .addLabel('t0')
  .to(`${hophSel} .sector-copy.title .copy .char`, {duration: 0.3, autoAlpha: 1, rotationX: '0deg', y: '0%', x: '0%', stagger: 0.05, ease: 'power2.out'}, 't0')
  .to(`${hophSel} .sector-copy.sentance .copy span`, {duration: 0.5, autoAlpha: 1, rotationX: '0deg', y: '0%', x: '0%', stagger:0.1, ease: 'back.out(2)'}, '-=0.25')
  .to(`${hophSel} .glass-cover-shadow, ${hophSel} .glass-cover-glow`, {duration: 0.25, opacity: 0, ease: 'power1.in'}, 't0')
    
  .addLabel('t1')  

  .to(`${hophSel} .wall-base .wall-bg`, {duration: 0.75, backgroundColor: '#fff', ease: 'none'}, 't1-=0.5')
  .to(`${hophSel} .gallery-cover1`, {duration: 0.5, opacity: 0, ease: 'none'}, 't1-=0.75')
  .to(`${hophSel} .sector-copies`, {duration: 0.5, scale: 8, opacity: 0, ease: 'power1.in'}, 't1')  
  ;

  //////////////////// Scroll2: After Photo on, animation while scrolling
  hophScrollTl2 = gsapRef.timeline({
    scrollTrigger: {
    id: 'hophScrollTl2',
    trigger: '.sector.spacer-graphic',
    toggleActions: 'restart complete reverse reset',
    start: 'top top',
    end: `bottom top` , // Used from .spacer-graphic
    scrub: 1.5,
    toggleClass: 'hophScrollTl2-active',
    // markers: {startColor: "black", endColor: "black", fontSize: "10px", fontWeight: "bold", indent: 0},
    }
  })
  .to(`${hophSel} .gallery-in-in`, {duration: 1, rotationX: '-1deg', ease: 'none'})

  .to(hophWallBaseT[0], {duration: 1, width: '20%', ease: 'none'}, 0)
  .to(hophWallBaseT[1], {duration: 1, width: '50%', height: '10%', ease: 'none'}, 0)
  .to(hophWallBaseT[2], {duration: 1, height: '40%', bottom: '10%', ease: 'none'}, 0)
  .to(hophWallBaseT[3], {duration: 1, width: '40%', ease: 'none'}, 0)
  .to(hophWallBaseT[4], {duration: 1, width: '45%', ease: 'none'}, 0)

  .to(hophWallBaseB[0], {duration: 1, width: '25%', ease: 'none'}, 0)
  .to(hophWallBaseB[1], {duration: 1, width: '40%', height: '10%', ease: 'none'}, 0)
  .to(hophWallBaseB[2], {duration: 1, height: '14%', top: '22%', ease: 'none'}, 0)
  .to(hophWallBaseB[3], {duration: 1, right: '10%', ease: 'none'}, 0)
  .to(hophWallBaseB[4], {duration: 1, right: '70%', ease: 'none'}, 0)

  .to(hophWallBaseL[0], {duration: 1, backgroundSize: '57% 45%', ease: 'none'}, 0)

  .to(hophWallBaseR[0], {duration: 1, x: '10%', ease: 'none'}, 0)
  .to(hophWallBaseR[1], {duration: 1, y: '20%', ease: 'none'}, 0)

  .to(hophWallBaseC[0], {duration: 1, width: '20%', ease: 'none'}, 0)
  .to(hophWallBaseC[1], {duration: 1, width: '35%', ease: 'none'}, 0)
  .to(hophWallBaseC[2], {duration: 1, height: '60%', ease: 'none'}, 0)
  .to(hophWallBaseC[3], {duration: 1, width: '20%', ease: 'none'}, 0)
  .to(hophWallBaseC[4], {duration: 1, right: '-3%', ease: 'none'}, 0)

  .to(hophWallObjT[0], {duration: 1, width: '5%', height: '20%', ease: 'none'}, 0)
  .to(hophWallObjT[1], {duration: 1, width: '60%', left: '20%', z: '0vh', ease: 'none'}, 0)
  .to(hophWallObjT[2], {duration: 1, right: '28%', z: '0vh', ease: 'none'}, 0)
  .to(hophWallObjT[3], {duration: 1, bottom: '45%', z: '-2vh', ease: 'none'}, 0)
  .to(hophWallObjT[4], {duration: 1, height: '40%', ease: 'none'}, 0)

  .to(hophWallObjB[0], {duration: 1, top: '35%', ease: 'none'}, 0)
  .to(hophWallObjB[1], {duration: 1, height: '25%', ease: 'none'}, 0)
  .to(hophWallObjB[2], {duration: 1, top: '45%', ease: 'none'}, 0)
  .to(hophWallObjB[3], {duration: 1, z: '11vh', ease: 'none'}, 0)
  .to(hophWallObjB[4], {duration: 1, top: '20%', ease: 'none'}, 0)

  .to(hophWallObjL[0], {duration: 1, backgroundSize: '30% 110%', backgroundPosition: '24% 255%', z: '3vw', ease: 'none'}, 0)

  .to(hophWallObjR[0], {duration: 1, backgroundSize: '25% 90%%', backgroundPosition: '21% 0', z: '3.5vw', ease: 'none'}, 0)

  .to(hophWallObjC[0], {duration: 1, height: '70%', ease: 'none'}, 0)
  .to(hophWallObjC[1], {duration: 1, width: '35%', ease: 'none'}, 0)
  .to(hophWallObjC[2], {duration: 1, width: '22%', ease: 'none'}, 0)
  .to(hophWallObjC[3], {duration: 1, width: '35%', ease: 'none'}, 0)
  .to(hophWallObjC[4], {duration: 1, width: '28%', ease: 'none'}, 0)

  ;

} // hophScrollMake END

////////////////////////////////////////////////// Scroll: clear
const hophScrollClear = () => {
  if(hophScrollTl1) {hophScrollTl1.revert(); hophScrollTl1 = null;}
  if(hophScrollTl2) {hophScrollTl2.revert(); hophScrollTl2 = null;}
  if(hophPhotoOnTl) {hophPhotoOnTl.revert(); hophPhotoOnTl = null;}
  if(hophTitle) {hophTitle.revert(); hophTitle = null;}
  if(hophCopyTl) {hophCopyTl.revert(); hophCopyTl = null;}
  if(hophWallLeftTl) {hophWallLeftTl.revert(); hophWallLeftTl = null;}
  if(hophWallRightTl) {hophWallRightTl.revert(); hophWallRightTl = null;}
  if(hophWallCenterTl) {hophWallCenterTl.revert(); hophWallCenterTl = null;}
}

////////////////////////////////////////////////// Code for snippet
// if(hophIsSnippet) {
//   hophInit(gsap, splitText);
//   hophScrollMake(gsap, scrollTrigger, smoother);
// }



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Elements Animation Control
const hophElsControl = (opt='play') => {
  if(opt === 'play') {
    tlControl([hophWallLeftTl, hophWallRightTl, hophWallCenterTl], 'play');

  } else {
    tlControl([hophWallLeftTl, hophWallRightTl, hophWallCenterTl], 'pause');
  }
}



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Resizing

const hophResizeStart = (gsapRef, scrollTriggerRef, smootherRef, splitTextRef) => {
  console.log("[home photo] Resize: START");
}

const hophResizeDone = (gsapRef, scrollTriggerRef, smootherRef, splitTextRef) => {
  console.log("[home photo] Resize: END");

  hophScrollClear();
  hophInit(gsapRef, splitTextRef);
  hophScrollMake(gsapRef, scrollTriggerRef, smootherRef);
}

////////////////////////////////////////////////// Code for snippet
// let hophResizing = false;
// const hophResizeHandler = (e) => {
//   if(!hophResizing) {
//     hophResizing = true;
//     smootherRef.paused(true);
//     scrollTriggerRef.disable();

//     hophResizeStart(gsapRef, scrollTriggerRef, smootherRef, splitTextRef);
//   }

//   waitForFinalEvent(function() {
//     hophResizing = false;
//     smootherRef.paused(false);
//     scrollTriggerRef.enable();
//     scrollTriggerRef.refresh(); // jess: After resizing done, refresh the ScrollTrigger

//     hophResizeDone(gsapRef, scrollTriggerRef, smootherRef, splitTextRef);
//   }, 1000, 'hophResize');
// }
// if(hophIsSnippet) {
//   if(typeof hophIsRevert !== 'undefined') window.removeEventListener('resize', hophResizeHandlerRef);
//   window.hophResizeHandlerRef = hophResizeHandler;
//   window.addEventListener('resize', hophResizeHandlerRef);
// }



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Control Key

////////////////////////////////////////////////// Play / Pause Elements animation
const hophControlKey = (key) => {
  if(!document.querySelector(".page-home") || !hophWallLeftTl) return;

  let opt = hophWallLeftTl.paused() ? "play" : "pause"
  tlPlayPause([hophWallLeftTl, hophWallRightTl, hophWallCenterTl], 'hophWall Tls', `[home: photo] [key: ${key} pressed] Elements animation: ${opt}`, false);
};

////////////////////////////////////////////////// Code for snippet
// const hophControlKeyHandler = (e) => { if(e.key === '5') hophControlKey(e.key); }
// if(hophIsSnippet) {
//  if(typeof hophIsRevert !== 'undefined') window.removeEventListener('keydown', hophControlKeyHandlerRef);
//   window.hophControlKeyHandlerRef = hophControlKeyHandler;
//   window.addEventListener('keydown', hophControlKeyHandlerRef);
// }



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Code for snippet
// if(hophIsSnippet) var hophIsRevert = true;



//////////////////////////////////////////////////////////////////////////////////////////////////
/// Export
export {
  hophInit,
  // hophWallTlMake,
  hophScrollMake,
  hophScrollClear,
  hophElsControl,
  hophResizeStart,
  hophResizeDone,
  hophControlKey
}